<template>
  <div v-if="data !== undefined" class="teasers">
    <Blocks :items="data.content?.list" class="teasers__content" />
  </div>
</template>

<script setup lang="ts">
import { type ParagraphTeasersFragment } from '#graphql-operations'
defineProps<{
  data: ParagraphTeasersFragment
}>()

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.teasers {
  @include tools.page-grid-columns-wide;
  @include tools.to(tools.$breakpoint--mobile) {
    margin-bottom: var(--space--m);
  }
  @include tools.from(tools.$breakpoint--desktop) {
    margin-bottom: var(--space--xl);
  }

  &:has(+ .teasers),
  &:last-child {
    margin-bottom: 0
  }

  &__content {
    @include tools.grid(1);
    row-gap: calc(var(--grid-gutter) * 2);
    @include tools.from(tools.$breakpoint--desktop) {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    }
  }
}
</style>
